
<template>
  <text :class="['dof-text', textTheme,hasTextMargin ? 'margin-text' : '']" :style="themeStyle">{{textValue}}</text>
</template>

<style scoped>
.dof-text {
  font-size: 24px;
  color: #3d3d3d;
}

.black {
  color: #3D3D3D;
}

.yellow {
  color: #EE9900;
}

.blue {
  color: #00A4F2;
}

.gray {
  color: #A5A5A5;
}

.red {
  color: #FF5000;
}

.margin-text {
  margin-right: 4px;
}
</style>

<script>
export default {
  props: {
    textValue: {
      type: String,
      default: ''
    },
    textTheme: {
      type: String,
      default: 'gray'
    },
    textStyle: {
      type: Object,
      default: () => ({})
    },
    hasTextMargin: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    themeStyle () {
      let style = {};
      const textStyle = this.textStyle;
      if (textStyle && textStyle.fontSize) {
        style = {
          ...style,
          fontSize: `${textStyle.fontSize}px`,
          height: `${textStyle.fontSize * 1.2}px`,
          marginTop: `${textStyle.fontSize * 0.1}px`,
        };
      }
      if (textStyle && textStyle.color) {
        style = {
          ...style,
          color: textStyle.color
        };
      }
      return style;
    }
  }
};
</script>



// WEBPACK FOOTER //
// dof-rich-text-text.vue?35b0c12e